<script>
  import options from './PostComments.options'
  export default options
</script>

<template>
  <section class="kb-post-comments">
    
    <div v-if="comments !== undefined">
      <h2 class="kb-post-comments__title">{{ comments.length }} {{ getLabel('title') }}</h2>
      <template v-for="comment, index in comments" :key="index">
        <div class="kb-post-comments__comment">
          <PostComment
            :comment="comment"
            :canReply="canReply"
            :subComments="comment.subcomments"
            :postId="postId"
            :groupId="groupId"
            :isFrivilligContext="isFrivilligContext"
          /> 
        </div>
      </template>
    </div>
    <div v-else class="kb-spinner-overlay">
      <div
        class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"
      ></div>
    </div>
    
  </section>
</template>
